import tns from '@/lib/tiny-slider/tiny-slider.js';

var tcCarousel;

document.addEventListener(
    "DOMContentLoaded", () => {
        var urlParams = new URLSearchParams(window.location.search);
        var eventSpaceId = urlParams.get('eventSpaceId');

        if (eventSpaceId) {
            getEventSpaceDetails(eventSpaceId);

            document.querySelector(".event-space-overview-link.selected").classList.remove('selected');
            document.querySelector(".event-space-overview-link[data-event-space-id='" + eventSpaceId + "']").classList.add("selected");

            var scrollElement = document.getElementById("event-spaces-overview-ctrl");
            scrollElement.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            createCarousel();
        }
    }
);

const eventSpaceLinks = document.querySelectorAll('.event-space-overview-link');
eventSpaceLinks.forEach(el => el.addEventListener('click', event => {
    event.preventDefault();

    var eventSpaceId = el.dataset.eventSpaceId;

    getEventSpaceDetails(eventSpaceId);

    document.querySelector(".event-space-overview-link.selected").classList.remove('selected');

    el.classList.add('selected');
}));

async function getEventSpaceDetails(eventSpaceId) {
    try {
        const response = await fetch('/umbraco/surface/EventSpaceOverviewSurface/GetEventSpaceDetails?eventSpaceId=' + eventSpaceId);
        const body = await response.text();

        document.querySelector('.event-space-item-wrapper').innerHTML = body;

        createCarousel();
    } catch (error) {
        console.log(error);
    }
}

function createCarousel() {
    tcCarousel = tns({
        container: '.control-event-spaces-overview .event-space-gallery',
        items: 1,
        slideBy: 1,
        autoplay: false,
        controls: true,
        controlsPosition: true,
        nav: false,
        speed: 800,
        controlsContainer: document.querySelector('.control-event-spaces-overview .tns-controls')
    });
}
